import { useState } from 'react';
import ProfileMenu from './ProfileMenu';

export default function ProfileButton({ user }) {
    const [isShowProfile, setIsShowProfile] = useState(false);

    const toggleProfileMenu = () => setIsShowProfile(!isShowProfile);

    return (
        <div className="relative flex items-center">
            <img
                src={user?.image || '/images/avatar/UserNull.png'}
                width={32}
                height={32}
                className="rounded-full cursor-pointer"
                onClick={toggleProfileMenu}
                onError={(e) => {
                    e.target.src = "/images/avatar/UserNull.png";
                }}
                alt=""
            />
            {isShowProfile && (
                <ProfileMenu
                    isShowProfile={isShowProfile}
                    toggleProfileMenu={toggleProfileMenu}
                />
            )}
        </div>
    );
}
